var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepositsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_89",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_89)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9811 8.71153C17.9811 11.5263 14.9301 13.8066 11.1663 13.8066C7.40256 13.8066 4.35156 11.5263 4.35156 8.71153C4.35156 5.89672 7.40256 3.61646 11.1663 3.61646C14.9301 3.61646 17.9811 5.89672 17.9811 8.71153ZM22.1537 22.6031C25.9175 22.6031 28.9685 20.3219 28.9685 17.5081C28.9685 14.6941 25.9175 12.413 22.1537 12.413C18.3901 12.413 15.3391 14.6941 15.3391 17.5081C15.3391 20.3219 18.3901 22.6031 22.1537 22.6031ZM28.4577 22.287C28.6336 22.1027 28.9685 22.2218 28.9685 22.4766V23.2886C28.9685 26.1025 25.9175 28.3837 22.1537 28.3837C18.3901 28.3837 15.3391 26.1025 15.3391 23.2886V22.4766C15.3391 22.2218 15.674 22.1027 15.8499 22.287C17.3508 23.8581 19.6176 24.8589 22.1537 24.8589C24.69 24.8589 26.9568 23.8581 28.4577 22.287ZM12.742 21.5175C13.1749 21.4439 13.5926 21.7629 13.5926 22.2019V24.3398C13.5926 24.6373 13.3961 24.9014 13.1057 24.9658C12.4911 25.1023 11.8401 25.1749 11.1663 25.1749C7.40256 25.1749 4.35156 22.8946 4.35156 20.0798V19.295C4.35156 19.0221 4.68315 18.8885 4.86616 19.0818C6.3672 20.6485 8.63208 21.6493 11.1663 21.6493C11.7054 21.6493 12.2322 21.6041 12.742 21.5175ZM12.7446 15.9234C13.1767 15.8506 13.5926 16.1693 13.5926 16.6073V18.7454C13.5926 19.0429 13.3961 19.307 13.1057 19.3715C12.4911 19.5081 11.8401 19.5805 11.1663 19.5805C7.40256 19.5805 4.35156 17.2974 4.35156 14.4854V13.7007C4.35156 13.4278 4.68331 13.297 4.86632 13.4874C6.3672 15.0569 8.63224 16.0549 11.1663 16.0549C11.7062 16.0549 12.2339 16.0095 12.7446 15.9234Z",
    fill: "black"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_89)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.660156,
    width: 32,
    height: 32,
    fill: "#192852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_89"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.660156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositsIcon);
export default __webpack_public_path__ + "static/media/deposits-icon.e829f5f6dae5709d793b283b1c605449.svg";
export { ForwardRef as ReactComponent };